import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AddOutlined, EditOutlined, Inventory2Outlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from 'redux/slices/uiSlice';
import { BackButton, CustomButton, TableData } from 'components';
import { validatePermission } from 'helpers/authentication';
import { setCurrentOperator, setCurrentSegment, setProviderCreds, setProviderCredSelected } from 'redux/slices/admin/providerSlice';
import { Box, Grid } from '@mui/material';
import { getProviderCredsService } from 'services/admin/providerService';
import { errorAlert } from 'helpers/alerts';

function CredsScreen() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { current, providerCreds } = useSelector(store => store.providers)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        dispatch(setTitle('Credenciales Proveedores'));
        // eslint-disable-next-line
    }, [])
    useEffect(() => {
        setLoading(true)
        getProviderCredsService(current.host).then(response => {
            dispatch(setProviderCreds(response));
        }).catch(error => errorAlert(error))
            .finally(() => setLoading(false))
        // eslint-disable-next-line
    }, [current?.host])

    return (
        <>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <div>
                    <BackButton click={() => navigate('..')} />
                </div>
                <div className="container-title">
                    <div className="commerce">Credenciales</div>
                    <div className="bag">{current?.container_name} </div>
                </div>
                <div>
                </div>
            </Grid>
            <Box mt={-5} >
                <TableData
                    dataRows={providerCreds}
                    loading={loading}
                    headerButtons={[
                        validatePermission('proveedores', 'proveedores', ['agregar']) &&
                        <CustomButton
                            dark={true}
                            icon={<AddOutlined />}
                            key="addProviderCred"
                            name={"Nueva credencial"}
                            click={() => {
                                navigate("create");
                            }}
                        />,
                    ]}
                    dataTitle={[
                        "Proveedor",
                        "Nombre",
                        "Client Id",
                        "Username",
                        "Conectada",
                        "Conciliación",
                    ]}
                    formatter={({ conciliacion_service, name_connector, client_id, user_name, active, conciliacion }) => ([
                        conciliacion_service,
                        name_connector,
                        client_id,
                        user_name,
                        active ? "SI" : "NO",
                        conciliacion ? "ACTIVA" : "INACTIVA"
                    ])}
                    actions={[
                        validatePermission('proveedores', 'productos', ['ver']) &&
                        {
                            label: "Productos",
                            icon: <Inventory2Outlined />,
                            onClick: (data) => {
                                dispatch(setProviderCredSelected(data));
                                dispatch(setCurrentOperator(null));
                                dispatch(setCurrentSegment(null));
                                dispatch(setProviderCredSelected(data));
                                navigate(current.type === 'RECHARGE' ? "productos/tae" : "productos/pds");
                            },
                        },
                        validatePermission('proveedores', 'productos', ['editar']) &&
                        {
                            label: "Editar",
                            icon: <EditOutlined />,
                            onClick: (data) => {
                                dispatch(setProviderCredSelected(data));
                                navigate("edit");
                            },
                        },
                    ]}
                />
            </Box>
        </>

    );
}

export default CredsScreen;